import { render, staticRenderFns } from "./ManageProductGroups.modal.vue?vue&type=template&id=b2656368"
import script from "./ManageProductGroups.modal.vue?vue&type=script&lang=ts"
export * from "./ManageProductGroups.modal.vue?vue&type=script&lang=ts"
import style0 from "./ManageProductGroups.modal.vue?vue&type=style&index=0&id=b2656368&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports